import type { LucideIcon } from 'lucide-react';
import { create } from 'zustand';

// Copy is null unless a caller supplies it; ConfirmationDialog renders localized
// fallbacks so no English text is pinned in this store.
interface ConfirmationProperties {
  title: string | null;
  description: string | null;
  confirmText: string | null;
  confirmIcon: LucideIcon | null;
  confirmVariant: 'default' | 'destructive' | 'success' | 'warning' | 'info';
  cancelText: string | null;
  onConfirm: () => void;
  onCancel: () => void;
  isOpen: boolean;
}

interface ConfirmationState extends ConfirmationProperties {
  showConfirmation: (properties: Partial<ConfirmationProperties>) => void;
  close: () => void;
}

const initialProperties: ConfirmationProperties = {
  title: null,
  description: null,
  confirmText: null,
  confirmVariant: 'destructive',
  confirmIcon: null,
  cancelText: null,
  onConfirm: () => {},
  onCancel: () => {},
  isOpen: false,
};

export const useConfirmationStore = create<ConfirmationState>((set) => ({
  ...initialProperties,
  showConfirmation: (properties) =>
    set({
      ...initialProperties,
      ...properties,
      isOpen: true,
    }),
  close: () => set({ ...initialProperties }),
}));
